import * as React from "react";
import { SizeGuideModalView } from "./SizeGuideModalView.js";
import { useCmsData } from "../../../../../../../../context/context/CmsContext.js";
import { useProductData } from "../../../../../../../../context/context/product-context-hooks.js";
const SizeGuideModalContainer = () => {
  const { sizeGuideDocument } = useCmsData();
  const {
    activeVariant: { sku, displayName }
  } = useProductData();
  return /* @__PURE__ */ React.createElement(SizeGuideModalView, { sku, sizeGuideContent: sizeGuideDocument, productName: displayName });
};
export {
  SizeGuideModalContainer
};
//# sourceMappingURL=SizeGuideModalContainer.js.map
